export const SET_JOBS_RECOMMENDED_PERSON = 'SET_JOBS_RECOMMENDED_PERSON';
export const CACHE_JOBS_RECOMMENDED_PERSON = 'CACHE_JOBS_RECOMMENDED_PERSON';
export const SET_RECOMMENDATIONS_BY_JOB = 'SET_RECOMMENDATIONS_BY_JOB';
export const CACHE_RECOMMENDATIONS_BY_JOB = 'CACHE_RECOMMENDATIONS_BY_JOB';
export const SET_JOBS_I_WAS_INDICATED_PERSON = 'SET_JOBS_I_WAS_INDICATED_PERSON';
export const CACHE_JOBS_I_WAS_INDICATED_PERSON = 'CACHE_JOBS_I_WAS_INDICATED_PERSON';
export const SET_INDICATIONS_I_RECEIVED_BY_JOB = 'SET_INDICATIONS_I_RECEIVED_BY_JOB';
export const CACHE_INDICATIONS_I_RECEIVED_BY_JOB = 'CACHE_INDICATIONS_I_RECEIVED_BY_JOB';
export const SET_INDICATIONS_BY_JOB_ID = 'SET_INDICATIONS_BY_JOB_ID';
export const CACHE_INDICATIONS_BY_JOB_ID = 'CACHE_INDICATIONS_BY_JOB_ID';
